import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import moment from 'moment'
import { Input, Panel, PanelGroup, IconButton, Icon, Modal, Button, Row, Message } from 'rsuite'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import EditButton from '../../../components/buttons/editButton/EditButton'
import { mappingAddressData } from '../../../utils/addressUtil'
import WorkingGroupForm from '../../../components/forms/workingGroupForm/WorkingGroupForm'
import WorkingGroupView from './WorkingGroupView'
import scrollToComponent from 'react-scroll-to-component'
import {
  saveWorkingGroup,
  deleteWorkingGroup,
  updateWorkingGroup,
} from '../../../redux/actions/workingGroup'
import { startLoading, doneLoading } from '../../../utils/loading'
import { cloneDeep } from 'lodash-es'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'

export default function WorkingGroupWidget(props) {
  const { schema, setIsEditWidget, isEditWidget, onChangeIsEdit } = props
  const [isError, setIsError] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [rerender, setRerender] = useState(true)
  const [isDelete, setIsDelete] = useState(false)
  const [deleteIndex, setDeleteIndex] = useState()

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const [formSchema, setFormSchema] = useState(schema || [])

  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  useEffect(() => {
    if (isError.length == 0) {
      let arr = [...isError]
      for (let i = 0; i < formSchema.length; i++) {
        let data = false
        arr.push(data)
      }
      setIsError(arr)
    }
  }, [formSchema])

  const handleSaveWorkingGroup = async (id, request, index) => {
    startLoading()
    setIsLoading(true)
    handleSetIsError(formSchema.length - 1, false)
    try {
      const response = await saveWorkingGroup(id, request)

      if (response) {
        let _formSchema = formSchema
        _formSchema[index] = response
        setFormSchema(_formSchema)
        onChangeIsEdit(`projectTeam_${index}`, !isEditWidget[`projectTeam_${index}`])
        await dispatch(getSchemaSidebar(projectId))
      } else {
        handleSetIsError(formSchema.length - 1, true)
      }
    } catch (e) {
      handleSetIsError(formSchema.length - 1, true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDeleteWorkingGroup = async (id, workingId, index) => {
    startLoading()
    setIsLoading(true)
    handleSetIsError(index, false)
    try {
      const status = await deleteWorkingGroup(id, workingId)
      if (status == 200) {
        //call api get
        props.onDeleteSuccess()

        let _isError = [...isErr_isError]
        _isError.push(false)
        setIsError(_isError)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        handleSetIsError(index, true)
      }
      setRerender(!rerender)
    } catch (e) {
      handleSetIsError(index, true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpdateWorkingGroup = async (id, request, workingId, index) => {
    startLoading()
    setIsLoading(true)
    handleSetIsError(index, false)
    try {
      const response = await updateWorkingGroup(id, request, workingId)
      if (response) {
        let _formSchema = formSchema
        _formSchema[index] = response
        setFormSchema(_formSchema)
        onChangeIsEdit(`projectTeam_${index}`, !isEditWidget[`projectTeam_${index}`])
        await dispatch(getSchemaSidebar(projectId))
      } else {
        handleSetIsError(index, true)
      }
    } catch (e) {
      handleSetIsError(index, true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit', data)
    const formData = new FormData()

    let id = formSchema[data.selectedIndex].id || ''

    data.idCard?.forEach((element) => {
      formData.append('IdCardFile', element.blobFile)
    })

    formData.append('IdNumber', data.idNumber || '')
    formData.append('Honorific', data.honorific || '')
    formData.append('FirstName', data.firstName || '')
    formData.append('LastName', data.lastName || '')
    formData.append('Nationality', parseInt(data.nationality) || 1)
    formData.append('NationalityOther', data.nationalityInputOther || '')
    formData.append('Telephone', data.telephone || '')
    formData.append('Mobile', data.mobile || '')
    formData.append('Fax', data.fax || '')
    formData.append('Email', data.email || '')
    formData.append('LineId', data.lineId || '')
    formData.append('DateOfBirth', moment(data.dateOfBirth).format('YYYY/MM/DD') || '')

    formData.append('BuildingName', data.buildingName || '')
    formData.append('RoomNumber', data.roomNumber || '')
    formData.append('HouseNumber', data.houseNumber || '')
    formData.append('VillageNumber', data.villageNumber || '')
    formData.append('Lane', data.lane || '')
    formData.append('VillageName', data.villageName || '')
    formData.append('Road', data.road || '')
    formData.append('location', data.location || '')
    formData.append('ProjectPosition', data.projectPosition || '')
    formData.append('PositionExperience', data.positionExperience || '')

    formData.append('Id', id || '')
    formData.append('ProjectVersionId', projectId)
    formData.append('UserId', '111')

    if (id) {
      handleUpdateWorkingGroup(projectId, formData, id, data.selectedIndex)
    } else {
      handleSaveWorkingGroup(projectId, formData, data.selectedIndex)
    }
  }

  //add local form
  const handleAddNewWorker = () => {
    let newWorkerForm = cloneDeep(formSchema[0]) //clone formSchema from first worker
    console.log(newWorkerForm)
    //implement set all value = null
    let setAll = (obj, val) =>
      Object.keys(obj).forEach((k) => {
        if (k == 'id' || k == 'idCardFile') {
          obj[k] = ''
        } else if (k == 'nationality') {
          obj[k].value = 0 //set default nationality = 0
        } else if (k == 'title') {
          let number = formSchema.length + 1
          obj[k] = 'คณะทำงานคนที่ ' + number.toString()
        } else if (k == 'disabled') {
          obj[k] = false
        } else if (k == 'feedbackBySubject') {
          obj[k] = null
        } else {
          obj[k].value = val //set value = null
        }
      })

    setAll(newWorkerForm, '') //call function setAll value = null
    //push new worker
    let _formSchema = formSchema
    _formSchema.push(newWorkerForm)
    setFormSchema(_formSchema)

    //add new isEditWidget
    let editObj = isEditWidget
    editObj[`projectTeam_${_formSchema.length - 1}`] = false
    setIsEditWidget(editObj)

    //push new isError
    let _isError = [...isError]
    _isError.push(false)
    setIsError(_isError)
  }

  const handleDeleteWorker = (index) => {
    //call api delete
    let workingId = formSchema[index].id
    if (workingId) {
      handleDeleteWorkingGroup(projectId, workingId, index)
    } else {
      let _formSchema = formSchema
      _formSchema.splice(index, 1)
      setFormSchema(_formSchema)

      //delete isEditWidget by index key
      let _isEditWidget = isEditWidget
      delete _isEditWidget[`projectTeam_${index}`]

      //create new isEditWidget
      let editObj = {}
      _formSchema.forEach((item, newIndex) => {
        if (newIndex < index) {
          editObj[`projectTeam_${newIndex}`] = _isEditWidget[`projectTeam_${newIndex}`]
        } else {
          editObj[`projectTeam_${newIndex}`] = _isEditWidget[`projectTeam_${newIndex + 1}`]
        }
      })

      setIsEditWidget(editObj)

      let _isError = [...isError]
      _isError.splice(index, 1)
      setIsError(_isError)
    }
  }

  const handleSetIsError = (index, _isError) => {
    let arr = [...isError]
    if (arr.length != 0) arr.splice(index, 1, _isError)

    setIsError(arr)
    setRerender(!rerender)
  }

  return (
    <div>
      {formSchema.length != 0 &&
        formSchema.map((schema, index) => {
          let _isEdit = isEditWidget[`projectTeam_${index}`]
          let _isError = isError[index]
          return (
            <>
              <Panel shaded header={schema.title} bordered collapsible defaultExpanded key={index}>
                <WarningMessage message={schema?.feedbackBySubject} />

                {_isEdit && !schema.disabled ? (
                  <WorkingGroupForm
                    schema={schema}
                    selectedIndex={index}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    getValues={getValues}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  ></WorkingGroupForm>
                ) : (
                  <div>
                    <WorkingGroupView data={schema} />
                  </div>
                )}

                {!schema.disabled && (
                  <>
                    <hr />
                    {_isEdit ? (
                      <>
                        {_isError && (
                          <Row style={{ marginBottom: 10 }}>
                            <Message
                              showIcon
                              type="error"
                              description={
                                'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
                              }
                            />
                          </Row>
                        )}
                        <SaveButton onClick={handleSubmit(onSubmit)} />
                        <CancelButton
                          onClick={() => {
                            handleSetIsError(index, false)
                            onChangeIsEdit(
                              `projectTeam_${index}`,
                              !isEditWidget[`projectTeam_${index}`]
                            )
                          }}
                        />
                      </>
                    ) : (
                      <>
                        {_isError && (
                          <Row style={{ marginBottom: 10 }}>
                            <Message showIcon type="error" description={'ไม่สำเร็จ'} />
                          </Row>
                        )}
                        <EditButton
                          onClick={() => {
                            handleSetIsError(index, false)
                            onChangeIsEdit(
                              `projectTeam_${index}`,
                              !isEditWidget[`projectTeam_${index}`]
                            )
                          }}
                        >
                          แก้ไขข้อมูล{schema.title}
                        </EditButton>

                        {index == formSchema.length - 1 && (
                          <div style={{ textAlign: 'right', marginBottom: '10px', float: 'right' }}>
                            <IconButton
                              appearance="ghost"
                              onClick={() => {
                                handleAddNewWorker()
                              }}
                              icon={
                                <Icon
                                  appearance="ghost"
                                  icon="plus"
                                  className="bt-gost-icon-radius"
                                />
                              }
                            >
                              เพิ่มคณะทำงาน
                            </IconButton>
                          </div>
                        )}

                        {index <= formSchema.length - 1 && index != 0 && (
                          <div style={{ textAlign: 'right', marginBottom: '10px', float: 'right' }}>
                            <IconButton
                              appearance="ghost"
                              className="rs-btn-ghost-cancel"
                              onClick={() => {
                                setIsDelete(true)
                                setDeleteIndex(index)
                              }}
                              icon={
                                <Icon
                                  appearance="ghost"
                                  icon="trash"
                                  className="bt-gost-icon-radius-cancel"
                                />
                              }
                            >
                              ลบคณะทำงาน
                            </IconButton>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}

                <Modal
                  show={isDelete}
                  onHide={(e) => {
                    setIsDelete(false)
                  }}
                >
                  <Modal.Header>
                    <Modal.Title>ยืนยันการลบ</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>{'ยืนยันการลบ ' + schema.title}</Modal.Body>
                  <Modal.Footer>
                    <Button
                      onClick={(e) => {
                        handleDeleteWorker(deleteIndex)
                        setIsDelete(false)
                      }}
                      appearance="primary"
                    >
                      ลบ
                    </Button>
                    <Button
                      onClick={(e) => {
                        setIsDelete(false)
                        setDeleteIndex('')
                      }}
                      appearance="subtle"
                    >
                      ยกเลิก
                    </Button>
                  </Modal.Footer>
                </Modal>
              </Panel>
              <br />
            </>
          )
        })}
      <br />
      {isLoading && <OverlayLoader />}
    </div>
  )
}
